import { render, staticRenderFns } from "./MerchantManagementEdit.vue?vue&type=template&id=53a90c12&scoped=true"
import script from "./MerchantManagementEdit.vue?vue&type=script&lang=js"
export * from "./MerchantManagementEdit.vue?vue&type=script&lang=js"
import style0 from "./MerchantManagementEdit.vue?vue&type=style&index=0&id=53a90c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a90c12",
  null
  
)

export default component.exports